import axios from "axios"
export default class AxiosHandler {
  constructor(loading) {
    this.isPost = false
    this.loading = loading
  }
  async exeGet() {
    var _this = this
    this.initLoading()
    var config = { headers: this.header }
    try {
      return await axios
        .get(this.url, config)
        .then(function(response) {
          _this.manejarRs(response.data)
        })
        .catch(function(error) {
          console.log(error)
          _this.manejarRs(error.response)
        })
    } catch (e) {
      console.log(e)
      this.status = 500
      this.detalle = e
      this.data = []
    } finally {
      _this.hideLoading()
    }
  }

  prepare(url, header, body = null) {
    this.executing = true
    this.isPost = false
    this.header = header
    this.url = url
    this.postData = body
    this.withOverlay = true
    if (body) {
      this.isPost = true
    }
  }
  initLoading() {
    if (this.withOverlay) {
      this.loader = this.loading.show({
        // container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel
      })
    }
  }
  hideLoading() {
    if (this.withOverlay) {
      this.loader.hide()
      this.executing = false
    }
  }
  manejarRs(response) {
    try {
      switch (response.status) {
        case 200:
          this.manejoRsOk(response)
          break

        default:
          this.manejoError(response)
          break
      }
    } catch (e) {
      console.log(e)
    }
  }
  manejoRsOk(response) {
    this.data = response.data
    this.status = response.status
    this.passportHandler.setNewToken(response.accesos.token)
  }
  manejoError(response) {
    this.status = response.status
    this.data = response.data
  }
  getStatus() {
    return this.status
  }
  getData() {
    return this.data
  }
  getDetalle() {
    return this.detalle
  }
  setPostData(data) {
    this.isPost = true
    this.postData = data
  }
  async exePost() {
    this.initLoading()
    var _this = this
    var config = { headers: this.header }
    try {
      return await axios
        .post(this.url, this.postData, config)
        .then(function(response) {
          _this.manejarRs(response.data)
        })
        .catch(function(error) {
          _this.manejarRs(error.response)
        })
    } catch (e) {
      console.log(e)
      this.data = false
    } finally {
      _this.hideLoading()
    }
  }
  async exe() {
    this.data = null
    if (!this.isPost) {
      await this.exeGet()
      return
    }
    await this.exePost()
  }
  setHeader(header) {
    this.header = header
  }
  setPassportHandler(passport) {
    this.passportHandler = passport
  }
  overlay(valor) {
    // DEBE SER SETEADO LUEGO DEL PREPARE
    this.withOverlay = valor
  }
}
